// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dNCAO","placeholdersHeader":"styles_placeholdersHeader__36K1b","editorStyle":"styles_editorStyle__eSHwM","placeholdersBox":"styles_placeholdersBox__2ScYy"};